/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const navigation = () => {
  const hamburgers = document.querySelectorAll('.js-hamburger');
  const nav = document.querySelector('.js-navigation-mobile');
  const dropdownItems = document.querySelectorAll('.menu-item-has-children');

  const logo = document.querySelector('.js-header-logo');

  const searchToggleBtns = document.querySelectorAll('.js-search-toggle');
  const searchForm = document.querySelectorAll('.js-search-form');
  const searchClear = document.querySelectorAll('.js-search-clear');

  const currentLink = document.querySelector('.js-current-cpt-link');
  if (currentLink) {
    let selectedMenuItems = [currentLink.closest('.js-menu-level-2'), currentLink.closest('.js-menu-level-1')];
    selectedMenuItems.forEach(el => {
      el.classList.add('is-current-link');
    })
  }


  /**
   * Navigation tools
   */
  const switchHamburgerIcon = () => {
    hamburgers.forEach(hamburger => {
      hamburger.classList.toggle('u-hidden');
    });
  };

  const switchNavVisibility = () => {
    nav.classList.toggle('is-active');
  };

  hamburgers.forEach(hamburger => {
    hamburger.addEventListener('click', () => {
      switchHamburgerIcon();
      switchNavVisibility();
    });
  });

  dropdownItems.forEach(dropdownItem => {
    dropdownItem.addEventListener('click', event => {
      if (window.innerWidth < 1024) {
        event.stopPropagation();
        dropdownItem.classList.toggle('is-active');
      }
    });
  });


  /**
   * Search tools
   */
   searchToggleBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      btn.classList.toggle('u-hidden');
      let form = btn.parentNode.querySelector(".js-search-form");
      form.classList.toggle('u-hidden');
      form.classList.toggle('is-on');
      setTimeout(() => {
        form.querySelector('input').focus();
      }, 50);
    });
  });

  /**
   * Mobile only: hide logo on searching
   */
  document.querySelector('.js-header-mobile .js-search-toggle').addEventListener('click', () => {
    if (window.innerWidth < 1024){
      logo.classList.toggle('u-hidden');
    }
  });

  // document.querySelector('.js-header-mobile .js-search-input').addEventListener('blur', () => {
  //   if (window.innerWidth < 1024){
  //     logo.classList.remove('u-hidden');
  //   }
  // });


  searchClear.forEach(clear => {
    clear.addEventListener('click', e => {
      let input = clear.closest('form').querySelector('.js-search-input');
      input.value = '';
      input.focus();
    });
  });
};

export default navigation;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/navigation.js